// extracted by mini-css-extract-plugin
export default {"Subheader":"Subheader_Subheader__AF6aa"};